/* eslint-disable import/prefer-default-export */
import { css, keyframes } from "@emotion/css";
import { withBasicStyles } from "@/styles/common";
import { token, tokens } from "@/styles/tokens";

const blinkAnimation = keyframes`
  0%   { background-position-x: -200%; background-position-y: 100%; }
  25%  { background-position-x: -100%; background-position-y: 100%; }
  50%  { background-position-x: 0%;    background-position-y: 100%; }
  75%  { background-position-x: 100%;  background-position-y: 100%; }
  100% { background-position-x: 200%;  background-position-y: 100%; }
`;

export const useStyles = withBasicStyles(() => ({
  /* --- ThoughtChain --- */

  thoughtChainBlock: css`
    margin-bottom: ${token(tokens.spacingMd)};
    border-radius: ${token(tokens.borderRadius)};
    overflow: hidden;
  `,

  thoughtHeader: css`
    display: flex;
    align-items: center;
    padding: 10px 14px;
    cursor: pointer;
    user-select: none;
    transition: background 0.2s;
    &:hover {
      background: ${token(tokens.colorBgHover)};
      border-color: #ccc;
    }
  `,

  headerLeft: css`
    display: flex;
    align-items: center;
    gap: ${token(tokens.spacingSm)};
  `,

  caret: css`
    font-size: ${token(tokens.fontSizeSm)};
    color: ${token(tokens.colorTextSecondary)};
    transition: transform 0.2s;
    &.open {
      transform: rotate(90deg);
    }
  `,

  statusIcon: css`
    font-size: 14px;
    display: flex;
    align-items: center;
  `,

  headerTitle: css`
    font-size: ${token(tokens.fontSizeBase)};
    color: ${token(tokens.colorTextSecondary)};
    font-weight: 500;
  `,

  headerRight: css``,

  thinkingBody: css`
    padding: 0 ${token(tokens.spacingMd)};
    animation: fadeIn 0.2s ease-in-out;
  `,

  /* --- Timeline --- */

  timeline: css`
    width: 100%;
  `,

  timelineItem: css`
    display: flex;
    gap: 12px;
    position: relative;
  `,

  timelineLeft: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 20px;
    flex-shrink: 0;
  `,

  timelineIcon: css`
    color: ${token(tokens.colorTextSecondary)};
    font-size: 16px;
    margin-top: 6px;
  `,

  timelineIconTool: css`
    color: ${token(tokens.colorWarning)};
    font-size: 16px;
    margin-top: 6px;
  `,

  timelineConnector: css`
    flex: 1;
    width: 1px;
    background-color: ${token(tokens.colorBorder)};
    margin: 4px 0;
    min-height: 12px;
  `,

  /* Hide connector on last item */
  timelineItemLastConnector: css`
    display: none;
  `,

  timelineRight: css`
    flex: 1;
    padding-bottom: ${token(tokens.spacingSm)};
    min-width: 0;
  `,

  collapsibleHeader: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 8px;
    margin: 0 -8px 4px -8px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
    user-select: none;

    &:hover {
      background: ${token(tokens.colorBgHover)};
    }
  `,

  titleText: css`
    font-size: ${token(tokens.fontSizeBase)};
    font-weight: 600;
    color: ${token(tokens.colorTextSecondary)};
  `,

  toolTitleGroup: css`
    display: flex;
    align-items: center;
    gap: ${token(tokens.spacingSm)};
    overflow: hidden;
  `,

  toolName: css`
    font-size: ${token(tokens.fontSizeBase)};
    font-weight: 600;
    color: ${token(tokens.colorTextSecondary)};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,

  toolStatusTag: css`
    font-size: 11px;
    color: ${token(tokens.colorSuccess)};
    background: #f6ffed;
    border: 1px solid #b7eb8f;
    padding: 0 6px;
    border-radius: 4px;
    flex-shrink: 0;
  `,

  arrowIcon: css`
    font-size: 10px;
    color: #bbb;
    margin-left: ${token(tokens.spacingSm)};
  `,

  stepContent: css`
    font-size: ${token(tokens.fontSizeBase)};
    color: ${token(tokens.colorTextSecondary)};
    line-height: 1.6;
    padding-left: 4px;
  `,

  statusInfo: css`
    font-size: ${token(tokens.fontSizeSm)};
    color: ${token(tokens.colorTextSecondary)};
    margin-bottom: 4px;
    font-style: italic;
  `,

  blink: css`
    color: ${token(tokens.colorTextSecondary)};
    background-image: linear-gradient(
      90deg,
      transparent,
      rgba(0, 0, 0, 0.88),
      transparent
    );
    background-clip: text;
    -webkit-background-clip: text;
    background-size: 50%;
    background-repeat: no-repeat;
    animation-name: ${blinkAnimation};
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
  `,
}));
